import { Component, OnDestroy, OnInit } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TimestampFormatPipe } from '../../commons/timestampFormatPipe';
import { ComponentCacheService } from '../../services/component-cache.service';
import { CollaboratoreService } from '../../services/domain/collaboratore.service';
import { NavigatorService } from '../../services/navigator.service';
import { SondaggioService } from '../../services/sondaggio/sondaggio.service';
import { CollaboratoreDTO } from '../../shared/dto/domain/collaboratore';
import { ResponseQueryByCriteria } from '../../shared/dto/responseQueryByCriteria';
import { SondaggioDTO } from '../../shared/dto/sondaggi/sondaggio';
import { GenericListComponent } from '../../shared/GenericListCoumponent';

@Component({
  selector: 'app-creazione-sondaggi',
  templateUrl: './creazione-sondaggi.component.html',
  styleUrls: ['./creazione-sondaggi.component.scss']
})

export class CreazioneSondaggiComponent extends GenericListComponent implements OnInit, OnDestroy {

  collaboratori: CollaboratoreDTO[];
  collaboratore: CollaboratoreDTO;

  constructor(
    private sondaggioService: SondaggioService,
    private collaboratoreService: CollaboratoreService,
    componentCacheService: ComponentCacheService,
    navigatorService: NavigatorService,
    snackBar: MatSnackBar,
    dateAdapter: DateAdapter<Date>,
    router: Router,

    timestampFormatPipe: TimestampFormatPipe) {
    super(
      navigatorService,
      componentCacheService,
      dateAdapter,
      router,
      snackBar,
      timestampFormatPipe);
    this.displayedColumns = ['id', 'titolo', 'descrizione', 'creatore', 'dataCreazione', 'dataScadenza', 'isMultiple', 'rispostePresenti', 'votanti', 'detail'];
    this.parameters = {
      dataSource: [],
      showList: false,
      filter: null,
      sortField: null,
      sortDirection: null,
      pageNumber: 0,
      pageSize: 50,
      length: 0,

      titolo: null,
      creatore: null,
      dataCreazioneDa: null,
      dataCreazioneA: null,
      dataScadenzaDa: null,
      dataScadenzaA: null,
      rispostaMultipla: null,
    }
  }

  list() {
    this.sondaggioService.sondaggioListByList(
      this.parameters.pageNumber,
      this.parameters.pageSize,
      this.parameters.sortDirection,
      this.parameters.sortField,

      this.parameters.titolo,
      this.parameters.creatore,
      this.parameters.dataCreazioneDa,
      this.parameters.dataCreazioneA,
      this.parameters.dataScadenzaDa,
      this.parameters.dataScadenzaA,
      this.parameters.rispostaMultipla
      ).subscribe(
        (res: ResponseQueryByCriteria<SondaggioDTO>) => {
          console.log("response : ", res);
          this.parameters.dataSource = res.content;
          this.parameters.pageNumber = res.pageNumber;
          this.parameters.length = res.totalElements;
          this.parameters.showList = true;
        }
      )
  }

  ngOnInit() {
    super.ngOnInit();

    //Pre-seleziona il collaboratore in sessione
    if (!this.parameters.collaboratoreChanged) {
      this.navigatorService.collaboratore.subscribe(
        (res: CollaboratoreDTO) => {
          this.collaboratore = res;
          this.parameters.richiedente = this.collaboratore;
        }
      );
    }
    //Recupera la lista dei collaboratori per il menù a tendina
    this.collaboratoreService.collaboratoreList(
      0,
      9999,
      'ASC',
      'nome',
      '').subscribe(
        (res: ResponseQueryByCriteria<CollaboratoreDTO>) => {
          console.log("response : " + res);
          this.collaboratori = res.content;
        }
      );
    //Se non già valorizzata, inizializza DataDa con il primo del mese corrente
    if (this.parameters.dataDa == null && this.parameters.initDataDa) {
      this.parameters.dataDa = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    }
  }

  numRisposte(s: SondaggioDTO): number {
    return s.risposte?.length ?? 0;
  }

  votanti(s: SondaggioDTO): number {
    const numCollaboratori = new Set(s.risposte?.map(r => r.collaboratore.id));
    return numCollaboratori.size;
  }
  
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
